import { type FilterValues } from "components/filters/FilterContext";
import { mapAddressFilterToInstruction, mapArtistFilterToInstruction, mapBookkeepingFilterToInstruction, mapContactFilterToInstruction, mapCostCenterFilterToInstruction, mapHotelFilterToInstruction, mapKeywordFilterToInstruction, mapOnlyMySelectionFilterToInstruction, mapOwnersFilterToInstruction, mapPeriodFilterToInstruction, mapProductionFilterToInstruction, mapPromoterFilterToInstruction, mapPublicationFilterToInstruction, mapResponseToAddressFilter, mapResponseToArtistFilter, mapResponseToBookkeepingFilter, mapResponseToContactFilter, mapResponseToCostCenterFilter, mapResponseToHotelFilter, mapResponseToKeywordFilter, mapResponseToOnlyMySelectionFilter, mapResponseToOwnerFilter, mapResponseToPeriodFilter, mapResponseToProductionFilter, mapResponseToPromoterFilter, mapResponseToPublicationFilter, mapResponseToStatusFilter, mapResponseToTagFilter, mapResponseToVenueFilter, mapStatusFilterToInstruction, mapTagFilterToInstruction, mapVenueFilterToInstruction } from "components/filters/mappingUtils";
import { DefaultShowSortFilter, getSortOption } from "components/filters/Filters/FilterTypes/ShowSortFilterType";

export const mapFilterValuesToInstruction = (
  filterSet: server.dto.FilterSets,
  filter: FilterValues,
  page: number, 
  perPage: number
): server.dto.ListShowInternalInstruction => ({
  keyword: mapKeywordFilterToInstruction(filter.keyword),
  order: filter.showSort.sortOption.value,
  artistIds: mapArtistFilterToInstruction(filter.artist),
  bookkeepingIds: mapBookkeepingFilterToInstruction(filter.bookkeepings),
  statuses: mapStatusFilterToInstruction(filter.statuses),
  tags: mapTagFilterToInstruction(filter.tags),
  period: mapPeriodFilterToInstruction(filter.period),
  publication: mapPublicationFilterToInstruction(filter.publication),
  address: mapAddressFilterToInstruction(filter.address),
  productionIds: mapProductionFilterToInstruction(filter.production),
  ownerUserIds: mapOwnersFilterToInstruction(filter.owners),
  contactIds: mapContactFilterToInstruction(filter.contact),
  promoterIds: mapPromoterFilterToInstruction(filter.promoter),
  venueIds: mapVenueFilterToInstruction(filter.venue),
  hotelIds: mapHotelFilterToInstruction(filter.hotel),
  page,
  perPage,
  costCenterIds: mapCostCenterFilterToInstruction(filter.costCenter),
  onlyMySelection: mapOnlyMySelectionFilterToInstruction(filter.onlyMySelection),
  cache: filterSet
});

export const mapResponseToFilterValues = (
  response: server.dto.ListShowInternalFilters,
  values: FilterValues
): Partial<FilterValues> => ({
  showSort: {
    sortOption: (response.order !== "unknown") ? getSortOption(response.order) : getSortOption(DefaultShowSortFilter)
  },
  artist: mapResponseToArtistFilter(response.artists),
  bookkeepings: mapResponseToBookkeepingFilter(response.bookkeepings),
  statuses: mapResponseToStatusFilter(response.statuses, values.statuses),
  tags: mapResponseToTagFilter(response.tags, values.tags),
  contact: mapResponseToContactFilter(response.contacts),
  venue: mapResponseToVenueFilter(response.venues),
  hotel: mapResponseToHotelFilter(response.hotels),
  promoter: mapResponseToPromoterFilter(response.promoters),
  keyword: mapResponseToKeywordFilter(response.keyword),
  production: mapResponseToProductionFilter(response.productions),
  address: mapResponseToAddressFilter(response.address),
  period: mapResponseToPeriodFilter(response.period),
  publication: mapResponseToPublicationFilter(response.publication),
  owners: mapResponseToOwnerFilter(response.ownerUsers),
  costCenter: mapResponseToCostCenterFilter(response.costCenters),
  onlyMySelection: mapResponseToOnlyMySelectionFilter(response.onlyMySelection)
});
